const rankingItems = [
  {
    rank: 1,
    title: '她的私密恋爱',
    genre: '恋爱韩漫',
    heat: '本周热度 98.6万',
    desc: '办公室里的秘密恋情，每一话都让人心跳加速。细腻的情感刻画与真实的人物塑造，让这部韩漫成为当下最热门的恋爱漫画之一。',
  },
  {
    rank: 2,
    title: '暗夜行者',
    genre: '悬疑韩漫',
    heat: '本周热度 85.3万',
    desc: '夜幕降临，真相浮出水面。烧脑的悬疑设定与层层递进的剧情反转，让读者欲罢不能，是悬疑韩漫中的巅峰之作。',
  },
  {
    rank: 3,
    title: '异界剑圣传',
    genre: '奇幻韩漫',
    heat: '本周热度 72.1万',
    desc: '穿越异世界成为剑圣，史诗级战斗场面与宏大的世界观设定，奇幻韩漫爱好者不可错过的年度佳作。',
  },
  {
    rank: 4,
    title: '花郎之恋',
    genre: '古风韩漫',
    heat: '本周热度 64.8万',
    desc: '朝鲜时代的浪漫传奇，华美韩服与细腻宫廷画卷中展开的动人爱情故事，古风韩漫的极致美学体验。',
  },
  {
    rank: 5,
    title: '校园狂想曲',
    genre: '校园韩漫',
    heat: '本周热度 58.2万',
    desc: '青春校园里的欢乐日常，笑中带泪的成长故事。轻松明快的画风搭配温暖治愈的剧情，是校园韩漫中的一股清流。',
  },
];

const rankColors = ['bg-accent-500', 'bg-primary-500', 'bg-primary-400', 'text-foreground-500', 'text-foreground-500'];
const rankBgColors = ['bg-accent-500', 'bg-primary-500', 'bg-primary-400', 'bg-secondary-300', 'bg-secondary-300'];
const rankTextColors = ['text-background-50', 'text-background-50', 'text-background-50', 'text-foreground-600', 'text-foreground-600'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            人气榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            基于真实阅读数据与读者互动热度，每周更新的韩漫人气排行榜
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-5 md:space-y-6">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-4 md:gap-6 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl ${rankBgColors[item.rank - 1]} ${rankTextColors[item.rank - 1]} flex items-center justify-center font-heading font-bold text-lg md:text-xl`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-1.5 md:mb-2">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.genre}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}